import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../utils/helpers/model.helper';
import { fromJS, List, Record } from 'immutable';
import { XeroAccountCode } from './sub-models/xero-account-code.model';
import { XeroTax } from './sub-models/xero-tax.model';

export const XERO_ACCOUNT_SCHEMA = Object.freeze({
  IS_INTEGRATED: false,
  DEFAULT_ACCOUNT_CODE: '',
  XERO_ORG_NAME: '',
  ACCOUNT_CODES: null,
  AUTO_EXPORT: false,
  XERO_CURRENCY: '',
  XERO_TAXES: null,
  STATUS: '',
});

const RECORD = generateSchema(XERO_ACCOUNT_SCHEMA);
const KEYS: any = generateKeys(XERO_ACCOUNT_SCHEMA);

export class XeroAccount extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    return setInModel(this, [
      {
        key: KEYS.ACCOUNT_CODES,
        value: props.get(KEYS.ACCOUNT_CODES)
          ? this.accountCodes.map((params) => new XeroAccountCode(params))
          : List<XeroAccountCode>([]),
      },
      {
        key: KEYS.XERO_TAXES,
        value: props.get(KEYS.XERO_TAXES)
          ? this.xeroTaxes.map((params) => new XeroTax(params))
          : List<XeroTax>([]),
      },
    ]) as XeroAccount;
  }

  get isIntegrated(): boolean {
    return this.get(KEYS.IS_INTEGRATED);
  }

  get defaultAccountCode(): string {
    return this.get(KEYS.DEFAULT_ACCOUNT_CODE);
  }

  get xeroOrgName(): string {
    return this.get(KEYS.XERO_ORG_NAME);
  }

  get accountCodes(): List<XeroAccountCode> {
    return this.get(KEYS.ACCOUNT_CODES);
  }

  get autoExport(): boolean {
    return this.get(KEYS.AUTO_EXPORT);
  }

  get xeroCurrency(): string {
    return this.get(KEYS.XERO_CURRENCY);
  }

  get xeroTaxes(): List<XeroTax> {
    return this.get(KEYS.XERO_TAXES);
  }

  get status(): string {
    return this.get(KEYS.STATUS);
  }
}
